import { ref } from "vue";
import { exceptionRequestMsg, showToast } from "@/assets/js/util";
import { cotizacionUnidadMargenService } from "@/services/cotizacion-unidad-margenes.service";
import { cotizacionUnidadMargenResidualService } from "@/services/cotizacion-unidad-margenes-residual.service";
import { cotizacionUnidadHistorialService } from "@/services/cotizacion-unidad.service";
import { useRoute, useRouter } from "vue-router";

export const useCotizacionUnidadMargen = () => {
  const listaMargenes = ref([]);
  const get = async () => {
    try {
      const res = await cotizacionUnidadMargenService.get();
      listaMargenes.value = res.data;
    } catch (error) {
      exceptionRequestMsg(error);
    }
  };
  return {
    get,
    listaMargenes,
  };
};

export const useCotizacionUnidadMargenResidual = () => {
  const listaMargenes = ref([]);
  const get = async () => {
    try {
      const res = await cotizacionUnidadMargenResidualService.get();
      listaMargenes.value = res.data;
    } catch (error) {
      exceptionRequestMsg(error);
    }
  };
  return {
    get,
    listaMargenes,
  };
};

export const useCotizacionUnidad = () => {
  const route = useRoute();
  const router = useRouter();
  const cotizacion = ref(undefined);
  const agente = ref(undefined);
  const cotizacionDetalle = ref([]);
  const urlEndpoint = ref(null);
  const token = ref(undefined);

  token.value = route.params.token;

  urlEndpoint.value =
    process.env.VUE_APP_ENV == "production"
      ? process.env.VUE_APP_ENDPOINT_SERVER
      : process.env.VUE_APP_ENDPOINT_LOCAL;

  const getById = async () => {
    try {
      const res = await cotizacionUnidadHistorialService.getById(
        route.params.token
      );

      cotizacion.value = res.data.cotizacion;
      agente.value = res.data.agente;
      cotizacionDetalle.value = res.data.cotizacionDetalle;
    } catch (error) {
      console.error(error);
      exceptionRequestMsg(error);
    }
  };

  const copiarUrlAprobacion = async () => {
    navigator.clipboard
      .writeText(
        `${process.env.VUE_APP_URL}public/cotizacion/unidades/${token.value}`
      )
      .then(() => showToast("URL copiada al portapapeles", "info"))
      .catch((err) => console.error("Error al copiar:", err));
  };

  return {
    agente,
    copiarUrlAprobacion,
    cotizacion,
    cotizacionDetalle,
    getById,
    token,
    urlEndpoint,
  };
};

export const useCotizacionUnidadHistorial = () => {
  const listaCotizaciones = ref([]);
  const user = ref(undefined);
  const get = async () => {
    try {
      const res = await cotizacionUnidadHistorialService.get();
      listaCotizaciones.value = res.data.cotizacionUnidadHistorial;
      user.value = res.data.user;
    } catch (error) {
      exceptionRequestMsg(error);
    }
  };

  return {
    get,
    listaCotizaciones,
    user,
  };
};
